module.exports = __webpack_public_path__ + "assets/img/35-l.32fd47d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/35-l.jpg
// module id = RbU2
// module chunks = 0